import Menu from 'components/ui/Menu'
import { routes } from 'core/const/routes'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import * as S from './styles'

const Dashboard = () => {
  const router = useRouter()
  // const [items, setItems] = useState<StepsConsultoriaProps[]>([])
  useEffect(() => {
    router.replace(routes.minhasConsultorias)
    // setItems(itemsMock)
  }, [])
  const { asPath } = useRouter()
  return (
    <S.Wrapper>
      <S.Container>
        <Menu activeLink={asPath} />
        {/* <HeaderConsultancy /> */}
        {/* <AgendaConsultoria /> */}
      </S.Container>
    </S.Wrapper>
  )
}

export default Dashboard
